<template>
    <header class="columns">
        <div class="column is-9 pl-0">
            <h1 class="pl-1">
                <i class="fad fa-fw mr-4 ml-4 fa-chalkboard-teacher"></i>{{title}}
            </h1>
        </div>
        <div class="column menu has-text-right pr-0">
            <div class="pb-3">
                <b-button @click="$emit('close')" type="is-white" outlined>Close Course<i class="fas fa-times ml-3"></i></b-button>
            </div>
        </div>
    </header>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "CourseHeader",
        props: ['title', 'icon'],
        computed: {
            ...mapGetters(['currentUser']),
        },
        methods: {
            ...mapActions(['signOut']),
            logout: function() {
                this.signOut();
                this.$router.push({name: 'login'});
            }
        },
    };
</script>

<style lang="scss" scoped>
    header {
        padding: 0;
        margin: 0.657rem 0 2.5rem;
        color: rgba(255, 255, 255, 1);

        h1 {
            font-weight: 400;
            font-size: 22px;
            margin-top: 1.1rem;
            display: inline-block;
            cursor: pointer;

            strong {
                color: rgb(255, 255, 255);
            }

            i {
                vertical-align: middle;
                color: rgb(255, 255, 255);
            }
        }

        .menu {
            margin-top: 0.7rem;
        }
    }
</style>
